<main id="db-wrapper" class="bg-light">
  <app-admin-vetical-sidebar></app-admin-vetical-sidebar>
  <section id="page-content">
    <div class="header">
      <app-only-admin-navigation *ngIf="userRole=='Administrator'"></app-only-admin-navigation>
      <app-admin-nav *ngIf="userRole!='Administrator'"></app-admin-nav>
    </div>

    <div *ngIf="loading">
      <div class="container-fluid p-4">
        <div class="row">
          <div class="col-lg-12">
            <div class="border-bottom pb-4 mb-4 d-lg-flex justify-content-between align-items-center" >
              <div class="mb-3 mb-lg-0">
                <h1 class="mb-0 h2 fw-bold">
                  {{providername}}
                </h1>
              </div>
            </div>
          </div>
        </div>
        <div class="container">
         <div class="row">
          <div class="col-sm-12 mb-3 mb-xl-0" *ngFor="let item of [1,2,3,4,5,6,7,8,9]">
            <!-- Card -->
            <div class="card mb-4">
              <!-- Card body -->
              <div class="card-body" style="height: 200px;">
                <div class="skeleton-card"></div>
              </div>
            </div>
          </div>
         </div>
        </div>
    </div>

    </div>
    <div *ngIf="!loading">
      <div class="container-fluid p-4">
        <div class="row">
          <div class="col-lg-12">
            <div class="border-bottom pb-4 mb-4 d-lg-flex justify-content-between align-items-center" >
              <div class="mb-3 mb-lg-0">
                <h1 class="mb-0 h2 fw-bold">
                  {{providername}}
                </h1>
              </div>
            </div>
          </div>
        </div>
        <div class="container">

          <div class="row" >
            <div class="col-lg-12 mb-4" *ngFor="let item of news">
              <div class="card" [routerLink]="['/BusinessInsightDt',item.aritcleId]">
                <div class="row">

                 <div class="col-lg-12">

                 </div>
                  <div class="col-lg-12 col-md-12 col-12">
                    <div class="card-body">
                      <h3 class="mb-2  ">
                        <a [routerLink]="['/BusinessInsightDt',item.aritcleId]" class="text-inherit">
                          {{item.title}}
                        </a>
                      </h3>

                      <div class="row align-items-center g-0">
                        <div class="col-auto">
                          <img src="{{ getFaviconUrl(item.newsType)}}" class="rounded-circle avatar-xs" alt="">
                        </div>
                        <div class="col ms-2">
                          <span>
                            {{ getSiteName(item.newsType)}}
                          </span>

                        </div>
                        <div class="col ms-2">
                          <span>
                            Is Trends
                            {{ item.isTrend}}
                          </span>
                        </div>
                        <div class="col ms-2">
                          <span>
                            Is Competitor Activity
                            {{ item.isCompetitorActivity}}
                          </span>
                        </div>
                        <div class="col-auto">
                          <a class=" bookmark">
                           Sentiment:
                           {{item.sentiment}}
                          </a>
                        </div>
                      </div>
                      <div>
                      </div>
                    </div>
                  </div>
                </div>

              </div>
             </div>
          </div>
          <div class="row my-3" *ngIf="news.length>0">
            <div class="col-lg-12">
               <!-- disabled and active states -->
               <nav aria-label="...">
                <ul class="pagination">
                  <li class="page-item disabled">
                    <button class="page-link" (click)="previousPage()" [disabled]="pageNum === 1" >Previous</button>
                  </li>
                  <li class="page-item">
                  <button class="page-link" >
                    {{ pageNum }}
                  </button>
                 </li>
                  <li class="page-item">
                    <button class="page-link" (click)="nextPage()">Next</button>
                  </li>
                </ul>
              </nav>

            </div>
          </div>
        </div>
    </div>
    </div>


  </section>
</main>
<div class="d-block d-sm-block d-md-none d-lg-none d-xl-none mt-5">
  <app-bottom-nav></app-bottom-nav>
</div>
